import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { CheckmarkCircle, ExclamationTriangle } from '../../icons'

const ThresholdLabel = ({
  threshold,
  className,
  iconOnly,
  iconOnlyWhite
}) => {
  // TODO: Reuse these across the threshold files
  const THRESHOLD_LABEL = {
    critical: 'Needs reorder',
    ok: 'Needs reorder'
  }

  const THRESHOLD_ICON = {
    critical: <ExclamationTriangle />,
    ok: <ExclamationTriangle />,
    good: <CheckmarkCircle />,
    extra: <ExclamationTriangle />
  }

  return (
    <span
      className={
        classnames(
          'vs-threshold-label',
          { 'vs-threshold-label--critical': threshold === 'critical' },
          { 'vs-threshold-label--ok': threshold === 'ok' },
          { 'vs-threshold-label--good': threshold === 'good' },
          { 'vs-threshold-label--extra': threshold === 'extra' },
          { 'vs-threshold-label--just-icon': iconOnly },
          { 'vs-threshold-label--just-icon-white': iconOnlyWhite },
          className
        )
      }
    >
      {THRESHOLD_ICON[threshold]}
      {(!iconOnly && !iconOnlyWhite) && THRESHOLD_LABEL[threshold]}
    </span>
  )
}

ThresholdLabel.propTypes = {
  /**
   * The threshold
   */
  threshold: PropTypes.oneOf(['critical', 'ok', 'good', 'extra']),
  /**
   * Icon only
   */
  iconOnly: PropTypes.bool,
  /**
   * Icon only white - to be used when you just need white version of icon
   */
  iconOnlyWhite: PropTypes.bool
}

ThresholdLabel.defaultProps = {
  threshold: 'critical'
}

export default ThresholdLabel
